import { Controller } from "stimulus"
import lottie from "lottie-web"

export default class extends Controller {
  static values = { url: String, loop: String, preserveAspectRatio: String }

  connect() {
    if (!this.urlValue) return
    const loop = this.hasLoopValue ? this.loopValue !== "false" : true
    const rendererSettings = {}
    if (this.hasPreserveAspectRatioValue && this.preserveAspectRatioValue) {
      rendererSettings.preserveAspectRatio = this.preserveAspectRatioValue
    }
    this.animation = lottie.loadAnimation({
      container: this.element,
      path: this.urlValue,
      renderer: "svg",
      loop: loop,
      autoplay: true,
      rendererSettings: rendererSettings
    })
  }

  disconnect() {
    if (this.animation) {
      this.animation.destroy()
      this.animation = null
    }
  }
}
